<template>
    <a :href="getFullUrl(url)" class="d-inline-block mb-3 mb-sm-0 brand-logo">
        <img :src="image" :alt="name">
    </a>
</template>

<script>
    export default {
        props: {
            url: {
                type: String,
                default: '/',
            },
            image: {
                type: String,
                default: 'images/mr-movie-logo.svg',
            },
            name: {
                type: String,
                default: 'MrMovie',
            },
        },
        data() {
            return {
                queryString: '',
                applyQueryString: true,
            };
        },
        mounted() {
            let pathName = window.location.pathname;
            if(pathName.includes("/bioscopen")) {
                this.applyQueryString = false
            }


            if(this.applyQueryString) {
                this.updateQueryString();
                VueEvents.$on('loaded_filters', (filters) => {
                    this.updateQueryString();
                });

                VueEvents.$on('loaded_cinemas', (filters) => {
                    this.updateQueryString();
                });

                VueEvents.$on('loaded_movies', (filters) => {
                    this.updateQueryString();
                });
            }
        },
        methods: {
            updateQueryString()
            {
                if(this.applyQueryString) {
                    this.queryString = window.location.search;
                }

            },

            getFullUrl(url)
            {
                //return url + this.queryString;
                return url;
            }
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/HeaderHomeComponent.vue